import { StatusDot } from './StatusDot'
import { useQuery } from '@tanstack/react-query'
import { api, type MeResponse } from '../api/client'

export function TopBar() {
  const { data: me } = useQuery({
    queryKey: ['me'],
    queryFn: () => api.get<MeResponse>('/api/me'),
    retry: false,
  })

  const now = new Date()
  const ts = now.toISOString().replace('T', ' ').slice(0, 19) + ' UTC'

  return (
    <header className="h-12 flex items-center justify-between border-b border-ink-500 bg-ink-900/70 px-5">
      <div className="flex items-center gap-5">
        <span className="label">Node</span>
        <span className="font-mono text-[11px] text-paper tabular-nums">aamcirc-ec2</span>
        <span className="label">Env</span>
        <span className="font-mono text-[11px] text-amber-glow tabular-nums uppercase">prod</span>
        <span className="flex items-center gap-1.5">
          <StatusDot tone="ok" pulse />
          <span className="label-amber">ONLINE</span>
        </span>
      </div>

      <div className="flex items-center gap-5">
        <span className="font-mono text-[11px] text-paper-dim tabular-nums">{ts}</span>
        <span className="h-5 w-px bg-ink-500" />
        <span className="flex items-center gap-2">
          <span className="label">Operator</span>
          <span className="font-mono text-[11px] text-paper">
            {me?.email ?? <span className="text-paper-faint">—</span>}
          </span>
        </span>
      </div>
    </header>
  )
}
